import { useEffect } from "react";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Services } from "@/components/site/Services";
import { About } from "@/components/site/About";
import { Gallery } from "@/components/site/Gallery";
import { Testimonials } from "@/components/site/Testimonials";
import { QuoteForm } from "@/components/site/QuoteForm";
import { Footer } from "@/components/site/Footer";
import { ScrollToTop } from "@/components/site/ScrollToTop";

export default function Home() {
  useEffect(() => {
    document.title = "Canopy Grounds | Premium Landscaping Brantford, Ontario";
  }, []);

  return (
    <div className="bg-ink">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <About />
        <Gallery />
        <Testimonials />
        <QuoteForm />
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  );
}
